<template>
        <vue-form-generator 
            :ref="'vfg'"
            tag="div"
            :schema="formSchema.pages[0].schema" 
            :model="formSchema.model" 
            :options="formSchema.options">
        </vue-form-generator>
</template>

<script>
    // import VueFormGenerator from "vue-form-generator";
    Vue.use(VueFormGenerator); 
    
    export default {
        name: "blankForm",
        methods: {
        },

        // components: {  },

        // beforeCreate() {

        // }, 

        // created() {

        // }, 

        // beforeMount() {

        // },  

        // mounted() {

        // },

        // beforeDestroy() {

        // },  

        // destroyed() {

        // },
        
        props: ['formSchema' ],
        
        data: function() {
            return {
            }
        }

    }

</script>

<style>
    
</style>
